module.exports = __webpack_public_path__ + "img/fab-bg.1681f4e3.png";